import { Button } from "@/components/ui/Button";
import { Bot, ChevronRight } from "lucide-react";
import { useAgentStore } from "@/store/AgentStore";
import { useState } from "react";

interface AgentMenuProps {
  onNavigate?: (path: string) => void;
}

export function AgentMenu({ onNavigate }: AgentMenuProps) {
  const getDefaultAgent = useAgentStore((state) => state.getDefaultAgent);
  const defaultAgent = getDefaultAgent();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleClick = () => {
    setIsNavigating(true);
    setTimeout(() => {
      onNavigate?.("/agents");
      setIsNavigating(false);
    }, 200);
  };

  return (
    <Button
      variant="ghost"
      className="gap-3 w-full justify-between hover:bg-accent hover:text-blue-600 group px-2 text-[#0F0F0F] transition-all duration-200"
      onClick={handleClick}
      disabled={isNavigating}
    >
      <div className="flex items-center gap-3">
        <div 
          className="w-5.5 h-5.5 rounded-md flex items-center justify-center transition-transform duration-200 group-hover:scale-110"
          style={{ backgroundColor: defaultAgent.iconBgColor }}
        >
          <Bot 
            className="w-3.5 h-3.5" 
            style={{ color: defaultAgent.iconColor }}
          />
        </div>
        <span className="text-[#0F0F0F] text-base">{defaultAgent.name}</span>
      </div>
      <ChevronRight 
        className={`w-4 h-4 text-muted-foreground transition-transform duration-200 ${
          isNavigating ? 'translate-x-1' : 'group-hover:translate-x-1'
        }`} 
      />
    </Button>
  );
}

export default AgentMenu;
